import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { BiCheck, BiCheckDouble } from "react-icons/bi";
import { useForm } from "react-hook-form";

import { ExitResolver } from "../../../../../core/schemaValidations/tracking_sensors_exit";

import { Col } from "react-bootstrap";
import { CardSensors, Container } from "./styles";

interface IState {
  constantName: string;
  isOpen: boolean;
}

type FormValues = {
  vehicle_id: string;
  command_type_constant: string;
  action: string;
};

export const ActuatorCard: React.FC<any> = ({ data, onChange }: any) => {
  const { t } = useTranslation();

  const defaultValues: FormValues = {
    vehicle_id: data?.vehicle_id || 0,
    command_type_constant: "",
    action: "",
  };
  const {
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({
    defaultValues,
    resolver: ExitResolver,
  });

  function lockedOrUnlocked({ constantName, isOpen }: IState) {
    switch (constantName) {
      case "LEFT_DOOR":
      case "RIGHT_DOOR":
      case "SIDE_DOOR":
      case "FLUSH_DOOR": {
        return isOpen
          ? t("traking.task.modal_open")
          : t("traking.task.modal_locked");
      }
      case "SILO":
      case "FIFTH_WHEEL_LOCK":
      case "FUEL_BLOCK":
      case "FLUSH_DOOR_LOCK":
      case "SIDE_DOOR_LOCK":
      case "IGNITION_LOCK":
      case "FIFTH_WHEEL": {
        return isOpen
          ? t("traking.task.modal_blocked")
          : t("traking.task.modal_unblocked");
      }
      case "IGNITION":
      case "SIREM_ALARM_LOCK": {
        return isOpen
          ? t("traking.task.modal_on")
          : t("traking.task.modal_off");
      }
      case "PANIC_BUTTON": {
        return isOpen
          ? t("traking.task.modal_enabled")
          : t("traking.task.modal_disabled");
      }
      default:
        return "--";
    }
  }

  function lockedOrUnlockedButton({ constantName, isOpen }: IState) {
    switch (constantName) {
      case "LEFT_DOOR":
      case "RIGHT_DOOR":
      case "SIDE_DOOR_LOCK":
      case "SIDE_DOOR":
      case "FLUSH_DOOR_LOCK":
      case "FLUSH_DOOR": {
        return isOpen
          ? t("traking.task.modal_open")
          : t("traking.task.modal_lock");
      }
      case "SILO":
      case "FIFTH_WHEEL_LOCK":
      case "FUEL_BLOCK":
      case "IGNITION_LOCK":
      case "FIFTH_WHEEL": {
        return isOpen
          ? t("traking.task.modal_block")
          : t("traking.task.modal_unblock");
      }
      case "IGNITION":
      case "SIREM_ALARM_LOCK": {
        return isOpen
          ? t("traking.task.modal_turnon")
          : t("traking.task.modal_turnoff");
      }
      case "PANIC_BUTTON": {
        return isOpen
          ? t("traking.task.modal_enabled")
          : t("traking.task.modal_disabled");
      }
      default:
        return "--";
    }
    // switch (constantName) {
    //   case "LEFT_DOOR":
    //   case "RIGHT_DOOR":
    //   case "SIDE_DOOR":
    //   case "FLUSH_DOOR": {
    //     return isOpen
    //       ? t("traking.task.modal_unlock")
    //       : t("traking.task.modal_lock");
    //   }
    //   case "SILO":
    //   case "FIFTH_WHEEL_LOCK":
    //   case "FUEL_BLOCK":
    //   case "FLUSH_DOOR_LOCK":
    //   case "SIDE_DOOR_LOCK":
    //   case "IGNITION_LOCK":
    //   case "FIFTH_WHEEL": {
    //     return isOpen
    //       ? t("traking.task.modal_unblock")
    //       : t("traking.task.modal_block");
    //   }
    //   case "IGNITION":
    //   case "SIREM_ALARM_LOCK": {
    //     return isOpen
    //       ? t("traking.task.modal_turnoff")
    //       : t("traking.task.modal_turnon");
    //   }
    //   case "PANIC_BUTTON": {
    //     return isOpen
    //       ? t("traking.task.modal_disable")
    //       : t("traking.task.modal_enable");
    //   }
    //   default:
    //     return "--";
    // }
  }

  function getSensorsNames(constant: string) {
    switch (constant) {
      case "FUEL_BLOCK": {
        return <>{t("fleetmate.outings.fuel_block")}</>;
      }
      case "FLUSH_DOOR_LOCK": {
        return <>{t("fleetmate.outings.flush_door_lock")}</>;
      }
      case "SIDE_DOOR_LOCK": {
        return <>{t("fleetmate.outings.side_door_lock")}</>;
      }
      case "FIFTH_WHEEL_LOCK": {
        return <>{t("fleetmate.outings.fifth_wheel_lock")}</>;
      }
      case "SIREM_ALARM_LOCK": {
        return <>{t("fleetmate.outings.sirem_alarm_lock")}</>;
      }
      case "IGNITION_LOCK": {
        return <>{t("fleetmate.outings.ignition_lock")}</>;
      }
    }
  }

  return (
    <Col xs="4">
      <Container>
        <CardSensors>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
            className="status"
          >
            <h4
              style={{ fontSize: "1.25rem", marginBottom: "1rem" }}
              className="titleSensorsCard"
            >
              {data?.port?.constant
                ? getSensorsNames(data.port.constant)
                : "--"}
            </h4>
          </div>
          <button
            // key={i}
            type="submit"
            className="openCloseButton"
            onClick={() => {
              // onSubmitSensor(dataSensors, i);

              onChange();
            }}
          >
            {lockedOrUnlockedButton({
              constantName: data?.port?.constant || "",
              isOpen: data?.value === "1" ? true : false,
            })}
          </button>
          <div className="cardFooter">
            <div>
              <p style={{ fontSize: "14px", margin: 0 }}>
                {t("traking.task.modal_current_status")}:
              </p>
              <p style={{ fontSize: "14px", fontWeight: 600, margin: 0 }}>
                {lockedOrUnlocked({
                  constantName: data?.port?.constant || "",
                  isOpen: data?.value === "1" ? true : false,
                })}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              {isSubmitting ? (
                <BiCheck
                  color="#2F80ED"
                  style={{
                    marginRight: "6px",
                    marginTop: "7px",
                  }}
                />
              ) : (
                <BiCheckDouble
                  color="#2F80ED"
                  style={{
                    marginRight: "6px",
                    marginTop: "7px",
                  }}
                />
              )}
              <div>
                {isSubmitting ? (
                  <p style={{ fontSize: "12px", margin: 0 }}>
                    {t("traking.task.modal_executing")}
                  </p>
                ) : (
                  <p style={{ fontSize: "12px", margin: 0 }}>
                    {t("traking.task.modal_executed")}
                  </p>
                )}
                <p style={{ fontSize: "11px", margin: 0 }}>{data.updated_at}</p>
              </div>
            </div>
          </div>
        </CardSensors>
      </Container>
    </Col>
  );
};
